module.exports = __webpack_public_path__ + "img/BackgroundVjorngard0.729bb123.jpg";